import axios from 'axios';
import { reactLocalStorage } from 'reactjs-localstorage';
import Swal from 'sweetalert2';
import { keepAliveApi } from "./Redux/common/action";

let headers = {
    
};
const domain = window.location.origin;


let API_URL = "http://localhost:3000"

if (domain == "https://xtract.aventusdemo.com") {

    API_URL = process.env.REACT_APP_DEV_SERVER_API_URL + "/api";

}
else if (domain == "https://uat.db-xtract.com") {

    API_URL = process.env.REACT_APP_UAT_SERVER_API_URL + "/api";

}
else if (domain == "https://xtract-test.aventusinformatics.com") {

    API_URL = process.env.REACT_APP_TEST_SERVER_API_URL + "/api";

}
else if (domain == "https://training.db-xtract.com") {

    API_URL = process.env.REACT_APP_TRAINING_SERVER_API_URL + "/api";

}
else if (domain == "https://db-xtract.com") {

    API_URL = process.env.REACT_APP_PROD_SERVER_API_URL + "/api";

}
else if (domain == "https://test.db-xtract.com") {

    API_URL = process.env.REACT_APP_PROD_TEST_API_URL + "/api";

}
else if (domain == "https://demo.db-xtract.com") {

    API_URL = process.env.REACT_APP_DEMO_PROD_TEST_API_URL + "/api";

}
else if (domain == "https://training-cron-web.db-xtract.com") { 

    API_URL = process.env.REACT_APP_TRAINING_CRON_API_URL + "/api";

}
else if (domain == "http://localhost:3000") {

    API_URL = process.env.REACT_APP_DEV_SERVER_API_URL + "/api"; 

}
else {

    API_URL = process.env.REACT_APP_DEV_SERVER_API_URL + "/api";
    // API_URL = process.env.REACT_APP_UAT_SERVER_API_URL + "/api";

}
  

export const BACKEND_URL = API_URL;

const axiosInstance = axios.create({
    baseURL: BACKEND_URL,
    headers
});

axiosInstance.interceptors.request.use(
    async (config) => {

        const token = reactLocalStorage.get('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;

        }
        return config;

    },
    (error) => {

        return Promise.reject(error);
    },
);

let isSessionTimeoutActive = false;

const triggerSessionTimeout = (error) => {
    if (isSessionTimeoutActive) return;

    let apiUrl = error?.config?.url || 'Unknown API';
    if (error?.config?.method?.toLowerCase() === 'get' && apiUrl.includes('?')) {
        apiUrl = apiUrl.split('?')[0];
    }

    const isUnauthorized = (error?.response?.status === 401 || error?.response?.status_code === 401) && error?.config?.customData?.isKeepAliveLogin !== true;

    // if (window.top && typeof window.top.triggerParentSessionTimeout === 'function') {
    //     const fullMessage = `API: ${apiUrl}`;
    //     window.top.triggerParentSessionTimeout(isUnauthorized ? 'unauthorized' : 'api_error', fullMessage);
    //     return;
    // }

    if (isUnauthorized) {
        isSessionTimeoutActive = true;
        Swal.fire({
            title: 'Session Expired',
            text: 'Your session has expired. Please log in again to continue.',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#1ba1a6',
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(() => {
            isSessionTimeoutActive = false;
            reactLocalStorage.remove('token');
            localStorage.setItem("logout", Date.now());
            localStorage.clear();
            localStorage.setItem("check_session_time", "triggerSessionTimeout");
            console.log("check_session_time", "triggerSessionTimeout")

            parent.open("about:blank", "_self");
            parent.close();
        });
    }
};

axiosInstance.interceptors.response.use(
    (response) =>
        new Promise((resolve, reject) => {
            resolve(response);
        }),
    (error) => {
        if (!error.response) {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }

        if (error.response.status_code === 401 || error.response.status === 401) {
            if (!error?.config?.url?.includes('/auth/logout')) {
                triggerSessionTimeout(error);
            }
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }
        else {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }
    },
);

export default axiosInstance;